<template></template>

<script>

import Menu from "@/components/modules/adm/login/Menu.js";

import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

export default {
    name: "RefreshUserLogged",
    data() {
        return {
            urlGet: "/api/v1/adm/auth/renovate-userlogged-parameter",
            menu: new Menu(),
        }
    },
    computed: {
        ...mapGetters("generic", ["event"]),
        ...mapState("user", ["userLogged"]),
    },
    methods: {
        ...mapActions("generic", ["getApi"]),
        ...mapMutations("user", ["addUserLogged", "addItemMenu", "removeItemMenu"]),
        renovate() {
            let params = {
                url: this.urlGet,
                obj: {},
            };
            this.getApi(params).then((response) => {
                this.addUserLogged(response.content);
                this.loadMenu();
            });
        },
        loadMenu() {
            this.removeItemMenu();
            let self = this;
            this.userLogged.user.rules.forEach(function (rule) {
                self.hasRule(rule);
            });
        },
        hasRule(rule) {
            let self = this;
            this.menu.itens.forEach(function (item) {
                if (rule.name === item.rule) self.addItemMenu([item]);
            });
        },
    },
    watch: {
        event: {
            handler(event) {
                if (event.name == "renovateUserLogged")
                    this.renovate();
            },
            deep: true,
        },
    }
}

</script>